import React from 'react';
import { useTranslation } from 'react-i18next';

const SearchNotFound = ({type, searchVal}) => {
    const { t } = useTranslation()
    let liText = '';
    if (type == 'ai') {
        liText = t('Including archived workstreams');
    } else if (type == 'objective' || type == 'key_result') {
        liText = t('Including closed OKRs');
    }
    let isFilterApplied = false;
    if (searchVal) {
        isFilterApplied = true;
    }
    const emptyStyle = {
        textAlign: (isFilterApplied) ? 'left' : 'center'
    };
    return (
        <div className="empty-results-wrapper" style={emptyStyle}>
            {isFilterApplied ? 
                <div className="no-search-results-wrapper">
                    <div className="no-search-results">{t('No search results')}</div>
                    <div className="no-search-results-try">
                        <span>{t('You may want to try')}:</span>
                        <ul>
                            <li>{t('Using different keywords')}</li>
                            <li>{t('Checking for typos')}</li>
                            {liText ? (<li>{liText}</li>) : ''}
                        </ul>
                    </div>
                </div> :
                <div>
                    <div className="empty-results-image">
                        <img width="250" alt="" src={`${wbConfig.baseUrl}/images/global_search/artboard-2-3-x@3x.png`} />
                    </div>
                    <div className="search-results-will">
                        {t('Try searching -- results will display here.')}
                    </div>
                </div>
            }
        </div>
    )
};

export default SearchNotFound;